module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Gold + Black Leather Closed.c8e1dcaa.png";